import React from "react"
import Layout from "../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>What is Avaya Spaces?</h1>
        </div>
        <ol>
          <li>
            <a href="#section1">What is Avaya Spaces?</a>
          </li>
          <li>
            <a href="#section2">What is the Avaya Spaces API?</a>
          </li>
          <li>
            <a href="#section3">Terminology</a>
          </li>
          <li>
            <a href="#section4">Getting Started</a>
          </li>
        </ol>
        <br />
        <div id="section1" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">1 What is Avaya Spaces?</h4>
          </div>
          <div className="panel-body">
            <p>
              Avaya Spaces is a combination of traditional chat rooms, video
              conferencing, task management tools, blogs, and other
              communication tools. The purpose of a space is to provide a common
              workspace for a group of people to collaborate efficiently. This
              API documentation is designed for an audience with a working
              knowledge of Spaces; if you haven’t already, check it out at{" "}
              <a href="https://spaces.avayacloud.com/">spaces.avayacloud.com</a>.
            </p>
          </div>
        </div>
        <div id="section2" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">2 What is the Avaya Spaces API?</h4>
          </div>
          <div className="panel-body">
            <p>
              The Avaya Spaces API is an interface that allows third-party
              developers to integrate their products with Avaya Spaces.
              Potential applications include browser extensions, mobile
              applications, desktop programs, and more. The API is RESTful,
              using HTTP requests to access the functions and data stored on
              Avaya Cloud servers. API requests will usually specify content in the
              JSON format within the request body, while responses will return
              content within a JSON under the "data" key.
            </p>
          </div>
        </div>
        <div id="section3" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">3 Terminology</h4>
          </div>
          <div className="panel-body">
            <p>
              To use this documentation effectively, it’s important for you as a
              developer to understand the terminology being used.
            </p>
            <p>There are two types of users on Avaya Spaces:</p>
            <ol>
              <li>
                <strong>Registered User.</strong> Only registered users can
                create a space and invite others.
              </li>
              <li>
                <strong>Anonymous User.</strong> Avaya Spaces allows
                unregistered individuals to join a space as an anonymous user.
                An anonymous user cannot own a space, and can only join a space
                as a guest. Anonymous users will still receive a JSON Web Token
                (JWT) for authentication in a session (this token expires in 24
                hours).
              </li>
            </ol>
            <p>There are two types of spaces:</p>
            <ol>
              <li>
                <strong>Group.</strong> Can have many space members.
              </li>
              <li>
                <strong>Direct.</strong>
                ul li Only has 2 users li Only has chat messages li Cannot
                remove party li Cannot invite additional parties li Cannot be
                archived
              </li>
            </ol>
            <p>There are three roles within a space:</p>
            <ol>
              <li>
                <strong>Admin.</strong>
                ul li Can invite other people to be an admin/member/guest of the
                space. li Can promote/demote any party in the space. li Can
                add/edit/delete any messages/posts/tasks. li Can remove any
                other party from space. li Can archive/unarchive the space.
              </li>
              <li>
                <strong>Member.</strong>
                ul li Can invite other people to be a guest of the space. Can
                remove guests from the space.
              </li>
              <li>
                <strong>Guest.</strong>
                ul li Guests can read the posted messages that were created
                since they joined, and can also send messages and participate in
                a call.
              </li>
            </ol>
            <p>
              Developers may frequently find the term "topic" used throughout
              the API reference. Don't be alarmed: the word "topic" is just a
              synonym for "space".{" "}
            </p>
          </div>
        </div>
        <div id="section4" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">4 Getting Started</h4>
          </div>
          <div className="panel-body">
            <p>
              Avaya Cloud recommends three different ways to get started. Developers
              who want to take their time and familiarize themselves with the
              technology being used beforehand will benefit from examining the{" "}
              <Link to="/protocols">technologies and protocols we use</Link>,
              then looking through the{" "}
              <Link to="/api/users/users_me">API reference</Link>.
              Alternatively, the <Link to="/tutorials/messages">tutorials</Link>{" "}
              can walk you through the process of creating a client-side
              application. Finally, experienced developers who want to
              immediately get to work with coding can{" "}
              <Link to="/guides/register">register an application</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)
